// extracted by css-extract-rspack-plugin
var _1 = "i2rUvPUC4IjqLy_t";
var _2 = "i2rUvPUC4IjqLy_t";
export { _1 as "draw-article", _2 as "drawArticle" }
